

































import eventTracker from '@/utils/eventTracker'
import wrappers from '@/mixins/wrappers'
import { TrialTime } from '@/types/user'
export default wrappers.extend({
  name: 'Goal-Start',
  computed: {
    trialTime (): TrialTime {
      return this.$store.getters['user/trialTime']
    }
  },
  methods: {
    async laterClickHandler () {
      eventTracker.track('Goals DayZeroSelection', { choice: 'later' })
      await this.navigate({
        name: 'Goal:Feedback',
        query: {
          variant: 'we_understand'
        }
      })
    },
    async nowClickHandler () {
      eventTracker.track('Goals DayZeroSelection', { choice: 'now' })
      await this.navigate({
        name: 'Goal:Input'
      })
    }
  }
})
